import { useTranslation } from "react-i18next";
import Box from "@mui/material/Box";

export const ResizeHandle = ({ onMouseDown }: { onMouseDown: () => void }) => {
  const { t } = useTranslation();

  return (
    <Box
      onMouseDown={onMouseDown}
      sx={{
        position: "absolute",
        top: 0,
        left: 0,
        height: "100%",
        width: "8px",
        cursor: "ew-resize",
        zIndex: 10,
        "&:hover": {
          backgroundColor: "action.hover",
        },
      }}
      tabIndex={-1}
      aria-label={t("duck:resize_panel")}
      role="separator"
    />
  );
};
